import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ProcedureTypeRadioButtonsComponent from './Component';

import {
  getProcedureOneSample,
  getInferentialStatistics
} from 'store/form/inferentialStatistics';

class ProcedureTypeRadioButtonsContainer extends React.PureComponent {
  render () {
    const { inferentialStatistics, procedureOneSample } = this.props;

    return (
      <ProcedureTypeRadioButtonsComponent
        procedureOneSample={procedureOneSample}
        inferentialStatistics={inferentialStatistics}
      />
    );
  }
}

ProcedureTypeRadioButtonsContainer.propTypes = {
  procedureOneSample: PropTypes.string,
  inferentialStatistics: PropTypes.string
};

const mapStateToProps = state => {
  return {
    procedureOneSample: getProcedureOneSample(state),
    inferentialStatistics: getInferentialStatistics(state)
  };
};

export default connect(mapStateToProps)(ProcedureTypeRadioButtonsContainer);
